export default "__VITE_ASSET__OGV$qXTG__"